import type { OrgCustomColors } from '@cognitoforms/types/server-types/model/org-custom-colors';
import { serviceRequest } from '../service-request';

export async function setOrgAppearanceColors(colors: OrgCustomColors) {
	return serviceRequest('svc/settings/org-appearance/colors', colors, { method: 'POST' });
}

export async function setOrgDefaultTypeface(useDefaultTypeface: boolean) {
	return serviceRequest('svc/settings/org-appearance/default-typeface', {}, { method: 'POST', query: { useDefaultTypeface: useDefaultTypeface.toString() } });
}

export async function setOrgAppearanceLogo(file: File) {
	const formData = new FormData();
	formData.append('_file', file);
	return serviceRequest('svc/settings/org-appearance/logo', formData, { useSubmissionToken: true });
}

export async function deleteOrgAppearanceLogo() {
	return serviceRequest('svc/settings/org-appearance/logo', {}, { method: 'DELETE', useSubmissionToken: true });
}